module.exports = __webpack_public_path__ + "img/slider5.3044e477.jpg";